import * as React from 'react';
import ForecastHeader from './Forecast/ForecastHeader';
import ForecastFilter from './Forecast/ForecastFilter';
import ForecastListing from './Forecast/ForecastListing';
import { useForecastStore } from 'src/hooks/forecast';
import { useEffect } from 'react';
import useReduxState from 'src/hooks/useReduxState';
import useCheckAuthPermissions from "../hooks/component/useCheckAuthPermissions";
import SystemAlerts from 'src/component/SystemAlerts';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Helper from 'src/support/Helper';


export function Forecast() {
    const [{ forecast_counts }, { get_forecast_data }] = useForecastStore();
    const [firstServerCall, setFirstServerCall] = useReduxState(true, 'setFirstServerCall')
    const [_check_p] = useCheckAuthPermissions();
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    useEffect(() => {
        async function fetchHere() {
            await fetchAPICall();
            await setFirstServerCall(false);
        }

        fetchHere()
    }, [])

    const fetchAPICall = async () => {
        await get_forecast_data({
            "searchKeyword": "",
            "cpnStatus": "",
            "pageNumber": 1,
            "pageSize": 20
        })
    };
    return (
        <>
            <div className='container'>

                <ForecastHeader />

                {
                    latest_system_notification_data.errorModule !== undefined &&
                    latest_system_notification_data.errorModule === 'exportMsg' &&
                    <div className='mt-2'>
                        <SystemAlerts />
                    </div>
                }

                <ForecastFilter />

                <ForecastListing />

            </div>
        </>
    );

}
